import { Grid } from "@mui/material";
import FormCard from "./FormCard";

export default function FormTypes({ account, setFormType }) {
  return (
    <>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <FormCard
            title="Zgłoszenie przez konto ZHP"
            subtitle="Wypełnimy formularz Twoimi danymi kontaktowymi na podstawie konta ZHP. Jeżeli będziemy mieli dodatkowe pytania lub potrzebowali szczegółów, to skontaktujemy się z Tobą."
            onClick={() => setFormType(2)}
            disabledNote="Aby skorzystać z tej opcji zaloguj się kontem ZHP, korzystając z przycisku w prawym górnym rogu."
            disabled={!account}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <FormCard
            title="Zgłoszenie nieanonimowe"
            subtitle="Po przesłaniu formularza otrzymasz potwierdzenie mailowe o przyjeciu zgłoszenia i wygenerowany numer. Jeżeli będziemy mieli dodatkowe pytania lub potrzebowali szczegółów, to skontaktujemy się z Tobą."
            onClick={() => setFormType(1)}
          />
        </Grid>
      </Grid>
    </>
  );
}
